export default __webpack_public_path__ + "static/media/close-30px-ec0f69.afc96920.svg";